<template>
  <div>
    <Header></Header>
    <div id="main">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h1>CLICK2GIV SOLUÇÕES ONLINE LTDA.</h1>
            <br />
            <h2>Click2giv LTDA.</h2>
            <br />
            <h3>Política de Privacidade</h3>
            <h4>17 de maio de 2016</h4>
            <br/>
            <p>Esta Política de Privacidade explica como são coletadas, utilizadas e divulgadas pela click2giv Serviços on Line Ltda. ("click2giv"), as informações sobre os Usuários. A Política de Privacidade aplica-se às informações que coletamos dos Usuários ao utilizarem-se de nossos Serviços ou da plataforma click2giv.</p>

            <h3>Coleta de Informações Pessoais</h3>
            <p>A click2giv coleta algumas informações pessoais do Usuário automaticamente na efetivação do cadastro no website tais como: seu nome, endereço de email, endereço residencial ou comercial e número de telefone. A click2giv coleta também algumas informações demográficas, tais como, idade, sexo, preferências e interesses. Há também a coleta de informações sobre as ferramentas e softwares utilizados que podem incluir: seu endereço de IP, tipo de navegador, nomes de domínio, tempos de acesso e consultas a páginas do website. Estas informações serão usadas pela click2giv para manter a qualidade do serviço e fornecer estatísticas gerais a respeito do uso da ferramenta web.</p>
            <p>A click2giv incentiva o Usuário a ler a Política de Privacidade de modo que o mesmo possa compreender como o website coleta, usa e compartilha suas informações. A click2giv não é responsável pela Política de Privacidade ou qualquer outro conteúdo exibido fora do seu website.</p>
            <br/>
            <h3>Uso de Informações Pessoais</h3>
            <p>A click2giv coleta e usa suas informações pessoais para operar o seu website e realizar os Serviços solicitados pelos próprios usuários. A click2giv usa também suas informações de identificação pessoal para informá-lo sobre outros produtos ou serviços disponíveis no website click2giv. A click2giv pode também contatá-lo através de enquetes para conduzir pesquisas sobre sua opinião acerca de serviços atuais ou de serviços novos ou potenciais. A click2giv não vende nem aluga suas listas de clientes a terceiros. Todos os terceiros são proibidos de usar a sua informação pessoal a não ser para fornecer serviços a click2giv, e são obrigados a manter a confidencialidade de suas informações.</p>
            <p>A click2giv se mantém informada sobre os acessos e visitas ao seu site a fim de determinar quais serviços são os mais populares. Estes dados poderão ser usados para satisfazer de maneira customizada, clientes cujo comportamento indique interesse por áreas específicas.</p>
            <p>O website da click2giv irá disponibilizar suas informações pessoais sem aviso prévio somente se forem requisitadas por lei ou se forem necessárias para: (a) estar em conformidade com mandados legais ou para obedecer a processos judiciais ou administrativos que deverão ser cumpridos pela empresa; (b) proteger e defender os direitos de propriedade da click2giv; e, (c) agir sob circunstancias que exijam proteção da segurança dos usuários da click2giv ou do público em geral.</p>
            <br/>
            <h3>Uso de Cookies</h3>
            <p>O site click2giv usa cookies para personalizar sua experiência online. Um cookie é um arquivo texto armazenado no seu computador por um servidor de páginas web. Os cookies não podem ser usados para executar programas ou enviar vírus para o seu computador. Os cookies são atribuídos exclusivamente a você, e só podem ser lidos pelo servidor que os enviou.</p>
            <p>Um dos propósitos principais dos cookies é economizar o seu tempo. O cookie informa ao servidor web que você retornou a uma página específica. Por exemplo, durante o login, você pode optar por guardar suas informações, dessa maneira toda vez que visitar nosso site, não será necessário preencher o seu email e senha.</p>
            <p>Você pode aceitar ou recusar os cookies. A maioria dos navegadores aceitam os cookies automaticamente, mas você pode modificar as configurações do seu navegador para rejeitá-los. Se você se decidir por não aceitar os cookies, você não terá a total experiência das características interativas dos serviços e dos websites click2giv que visitou.</p>
            <br/>
            <h3>Segurança das suas Informações Pessoais</h3>
            <p>A click2giv assegura que as suas informações pessoais não serão acessadas, usadas ou reveladas de forma não autorizada. A click2giv assegura que tais informações estão em um ambiente controlado, seguro e protegido de acessos não autorizados. Quando suas informações pessoais (como o número de cartão de crédito) são transmitidas para outros sites, as informações estão protegidas através do uso de encriptação, como o protocolo SSL - Secure Socket Layer.</p>
            <br/>
            <h3>Alteração da Política de Privacidade</h3>
            <p>A click2giv poderá, ocasionalmente, atualizar esta Política de Privacidade. A click2giv encoraja você a rever este documento periodicamente para estar informado sobre como a empresa está protegendo sua informação.</p>
            <br/>
            <h3>Atualizações da política de privacidade.</h3>
            <p>17 maio de 2016 </p>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>

import Header from './includes/Header'
import Footer from './includes/Footer'

export default {
  name: 'Login',
  components: {
    Header,
    Footer
  },
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#main{
  width: 100%;
  min-height: 500px;
  margin-top: 50px;
  display: inline-table;
  font-family: RalewayRegular;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Privacy.vue